import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import sbCreditCardUtility from '@sparta.sb-credit-cards.utilities/sb-credit-card-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import sbCreditCardsHelper, { learnMore, learnMoreUrl, termsAndConditions, applyNow, compareProduct } from '@sparta.sb-credit-cards.helpers/sb-credit-cards/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"card-catalogs\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":11,"column":37},"end":{"line":11,"column":54}}}))
    + "\"></div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bactm-products\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bactm") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":14,"column":38},"end":{"line":14,"column":52}}}))
    + "\"></div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\r\n  <div class=\"column small-12 large-10 large-centered cards-list-placeholder\"></div>\r\n</div>\r\n\r\n<div class=\"card-list\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":7,"column":33},"end":{"line":7,"column":47}}}))
    + "\"></div>\r\n<div class=\"card-content\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":8,"column":36},"end":{"line":8,"column":52}}}))
    + "\"></div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"catalogs") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":0},"end":{"line":12,"column":7}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bactm") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":0},"end":{"line":15,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$2 = function (data, options) {
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"barker")||(depth0 && lookupProperty(depth0,"barker"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),(depth0 != null ? lookupProperty(depth0,"campaign") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"barker","hash":{},"data":data,"loc":{"start":{"line":6,"column":34},"end":{"line":6,"column":123}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1), depth0)) != null ? stack1 : "")
    + "</span>";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\"\r\n        class=\"rating-link show-for-medium-up\" target=\"_blank\" rel=\"noopener noreferrer\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":13,"column":34}}}))
    + "\r\n        <div class=\"summary\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </a>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":6},"end":{"line":33,"column":18}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"offer-terms offer-terms_under-headline show-for-medium-up\">\r\n          "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndConditionOffer") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),true,((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"OFFER_TERMS_LABEL") : stack1),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":31,"column":10},"end":{"line":31,"column":127}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "h2";
},"12":function(container,depth0,helpers,partials,data) {
    return "h3";
},"14":function(container,depth0,helpers,partials,data) {
    return "h4";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a id=\"ratings-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "-small\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_VALUE") : stack1), depth0))
    + "\"\r\n        class=\"rating-link show-for-small-only\" target=\"_blank\" rel=\"noopener noreferrer\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"rating")||(depth0 && lookupProperty(depth0,"rating"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1),{"name":"rating","hash":{},"data":data,"loc":{"start":{"line":42,"column":8},"end":{"line":42,"column":34}}}))
    + "\r\n        <div class=\"summary\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_REVIEW_RATING_TEXT_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </a>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"program-rules\">\r\n          "
    + container.escapeExpression((lookupProperty(helpers,"getProgramRulesLink")||(depth0 && lookupProperty(depth0,"getProgramRulesLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"programRulesPopup") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LABEL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_LINK") : stack1),{"name":"getProgramRulesLink","hash":{},"data":data,"loc":{"start":{"line":84,"column":10},"end":{"line":84,"column":122}}}))
    + "\r\n        </p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row card-info\" data-campaign=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" data-group-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"GROUP_CODE") : stack1), depth0))
    + "\"\r\n  data-source-code=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"SOURCE_CODE") : stack1), depth0))
    + "\" data-product-name=\""
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"EPRODUCT_NAME") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n  <div class=\"small-12 medium-3 column card-info-left\">\r\n    <a href=\""
    + container.escapeExpression((lookupProperty(helpers,"learnMoreUrl")||(depth0 && lookupProperty(depth0,"learnMoreUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"learnMoreUrl","hash":{},"data":data,"loc":{"start":{"line":4,"column":13},"end":{"line":4,"column":65}}}))
    + "\" id=\"learn-more-image-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" class=\"learn\"\r\n      aria-hidden=\"true\">\r\n      "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":6,"column":130}}})) != null ? stack1 : "")
    + "\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image1") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":7,"column":34}}}))
    + "\r\n    </a>\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":9,"column":97}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":18,"column":16}}})) != null ? stack1 : "")
    + "    <p class=\"benefits show-for-medium-up\">\r\n      <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span> "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_AMF_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </p>\r\n    <div class=\"callout\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"image2") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":23,"column":6},"end":{"line":23,"column":32}}}))
    + "\r\n      <p class=\"callout-copy\">\r\n        <span class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1), depth0)) != null ? stack1 : "")
    + "</span> "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"callout") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </p>\r\n    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"hasOfferTermsBelowCard")),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":4},"end":{"line":34,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"small-12 medium-9 column\">\r\n    <"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"headingOverride")),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":37,"column":5},"end":{"line":37,"column":60}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = (lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreTitle") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":37,"column":61},"end":{"line":37,"column":141}}})) != null ? stack1 : "")
    + "</"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"headingOverride")),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":37,"column":143},"end":{"line":37,"column":198}}})) != null ? stack1 : "")
    + ">\r\n    <"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"headingOverride")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":38,"column":5},"end":{"line":38,"column":60}}})) != null ? stack1 : "")
    + " class=\"sub-heading\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PRODUCT_MB_INCENTIVE_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "</"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"params"))) && lookupProperty(stack1,"headingOverride")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":38,"column":124},"end":{"line":38,"column":179}}})) != null ? stack1 : "")
    + " >\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"rating") : stack1)) != null ? lookupProperty(stack1,"toggle") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":4},"end":{"line":47,"column":16}}})) != null ? stack1 : "")
    + "    <ul class=\"spa-accordion show-for-small-only\">\r\n      <li class=\"spa-accordion-item\">\r\n        <h4 class=\"spa-accordion-heading\">\r\n          <a class=\"spa-accordion-link\" href=\"#rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" id=\"toggle-rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\"\r\n            aria-expanded=\"false\" aria-controls=\"rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\">\r\n            <span class=\"spa-accordion-arrow spa-arrow-btn spa-arrow-btn--learn-more\"> </span>\r\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_RATES_FEES") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n          </a>\r\n        </h4>\r\n        <div id=\"rates-fees-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\" class=\"spa-accordion-content rates-fees-content\" aria-hidden=\"true\">\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_INTRO_APR") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"ratesDesc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_INTRO_APR_SHORT") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_STANDARD_APR") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"ratesDesc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_STANDARD_APR_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_ANNUAL_FEE") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"ratesDesc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_STANDARD_ANNUAL_FEE_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <h5>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"LABEL_BT_FEE") : stack1), depth0)) != null ? stack1 : "")
    + "</h5>\r\n          <div class=\"ratesDesc\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"INTEREST_RATES_FEES_BT_FEE_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"ratesFees\"><span\r\n              aria-hidden='true'><sup>&dagger;</sup></span>"
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"completeRatesAndFees") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":70,"column":59},"end":{"line":70,"column":142}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n        </div>\r\n      </li>\r\n    </ul>\r\n    <ul class=\"show-for-medium-up\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_BULLET_LIST_RESEARCH") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </ul>\r\n    <div class=\"terms-and-rules\">\r\n      <p class=\"terms show-for-medium-up\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"termsAndConditions")||(depth0 && lookupProperty(depth0,"termsAndConditions"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"termsAndCondition") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),{"name":"termsAndConditions","hash":{},"data":data,"loc":{"start":{"line":80,"column":6},"end":{"line":80,"column":86}}})) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"PROGRAM_RULES_ENABLE") : stack1),"==","YES",{"name":"compare","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":6},"end":{"line":86,"column":18}}})) != null ? stack1 : "")
    + "    </div>\r\n    <div class=\"cta-action show-for-medium-up\">\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),(depth0 != null ? lookupProperty(depth0,"catalog") : depth0),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":89,"column":6},"end":{"line":89,"column":124}}}))
    + "\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"compareProduct")||(depth0 && lookupProperty(depth0,"compareProduct"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"compare") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"compareLabel") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"CARD_IMAGE_SMALL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"compareProduct","hash":{},"data":data,"loc":{"start":{"line":90,"column":6},"end":{"line":90,"column":205}}}))
    + "\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreMediumUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":91,"column":6},"end":{"line":91,"column":87}}}))
    + "\r\n    </div>\r\n    <div class=\"cta-action show-for-small-only\">\r\n      <div class=\"cta-action-sm\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"applyNow")||(depth0 && lookupProperty(depth0,"applyNow"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"applyNowSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"params") : depth0)) != null ? lookupProperty(stack1,"requesttype") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"sparta") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BYAPAGE_ENABLE") : stack1),(depth0 != null ? lookupProperty(depth0,"catalog") : depth0),{"name":"applyNow","hash":{},"data":data,"loc":{"start":{"line":95,"column":8},"end":{"line":95,"column":123}}}))
    + "\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"compareProduct")||(depth0 && lookupProperty(depth0,"compareProduct"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"compare") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"compareLabel") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"MARKETING_PRODUCT_NAME_LONG") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"CARD_IMAGE_SMALL") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_TEXT") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_POSITION") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"BARKER_COLOR") : stack1),{"name":"compareProduct","hash":{},"data":data,"loc":{"start":{"line":96,"column":8},"end":{"line":96,"column":207}}}))
    + "\r\n      </div>\r\n      "
    + container.escapeExpression((lookupProperty(helpers,"learnMore")||(depth0 && lookupProperty(depth0,"learnMore"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"learnMoreSmall") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"cardInfo") : depth0)) != null ? lookupProperty(stack1,"learnMore") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"campaign") : depth0)) != null ? lookupProperty(stack1,"ID") : stack1),(depth0 != null ? lookupProperty(depth0,"site") : depth0),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":98,"column":6},"end":{"line":98,"column":84}}}))
    + "\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/card-list-cc-module",
  "version": "4.0.2",
  "id": "cardListCcModule",
  "containerID": "sbCreditCardsCardListCcModule",
  "moduleName": "sb-credit-cards-card-list-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "card-list-cc-module",
  "data": {
    "init": "cardListCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "headingOverride",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter allows for overriding the default heading in the title from h3 to be h2.  Some pages don't have h2."
  }, {
    "name": "filter",
    "type": "object",
    "default": {},
    "description": "Filter for the cards to be displayed. See README.md"
  }, {
    "name": "id",
    "type": "string",
    "values": ["popularCards"],
    "default": "popularCards",
    "description": "predefined IDs"
  }, {
    "name": "requestParams",
    "type": "object",
    "default": {},
    "description": "Query string parameters to the service."
  }, {
    "name": "requesttype",
    "values": ["C", "BCC"],
    "default": "BCC",
    "description": "Consumer or Small Business Request Type"
  }, {
    "name": "hasOfferTermsBelowCard",
    "type": "Boolean",
    "default": false,
    "description": "Show Offer Terms (if available via PCM) below the product card"
  }, {
    "name": "hasProgramRulesLink",
    "type": "Boolean",
    "default": false,
    "description": "Show Program Rules link (if available via PCM)"
  }, {
    "name": "useaccordion",
    "values": [true, false],
    "default": false,
    "description": "Consumer or Small Business Request Type"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$2(context, {
      "helpers": {
        compare,
        learnMore,
        learnMoreUrl,
        termsAndConditions,
        applyNow,
        compareProduct,
        json,
        picture
      },
      "partials": {
        "card-info": renderTemplate$1,
        "accordion": renderTemplate
      }
    });
  },
  "template": renderTemplate$2,
  "partials": {
    "card-info": renderTemplate$1,
    "accordion": renderTemplate
  },
  "helpers": {
    compare,
    learnMore,
    learnMoreUrl,
    termsAndConditions,
    applyNow,
    compareProduct,
    json,
    picture
  },
  "dependencies": {
    "@sparta.global.helpers/checkbox-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.sb-credit-cards.helpers/sb-credit-cards": "^2.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/picturefill": "^3.0.2",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.1"
  },
  "stores": []
};

/* global spaParams sparta bactm  */

/**
 * @class cardListCcModuleJS
 * @extends {Module}
 */
class cardListCcModuleJS extends Module {
  /**
   * Creates an instance
   * @param {object} options options
   * @param {object} context context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.templateCardInfo = _moduleConfig.partials['card-info'];
    try {
      this.cardContent = JSON.parse(target.querySelector('.card-content').dataset.jcr);
      this.cardList = Object.values(JSON.parse(target.querySelector('.card-list').dataset.jcr));
      this.cardCatalogsEl = target.querySelector('.card-catalogs');
      this.cardCatalogs = this.cardCatalogsEl ? Object.values(JSON.parse(this.cardCatalogsEl.dataset.jcr)) : [];
      this.bactmProductsEl = target.querySelector('.bactm-products');
      this.bactmProducts = this.bactmProductsEl ? JSON.parse(this.bactmProductsEl.dataset.jcr) : {};
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);
    }
    this.campaignData = {};
  }

  /**
   * init
   * @returns {void}
   */
  init() {
    this.renderList();
    this.bindEventListeners();
    this.bindEvents();
  }

  /**
   * changeCompareStyle
   * @returns {void}
   */
  changeCompareStyle() {
    const compareSmallSelectors = document.querySelectorAll('.show-for-small-only .compare-selector .spa-input');
    Array.from(compareSmallSelectors).forEach(compareSelector => {
      compareSelector.classList.add('spa-btn', 'spa-btn--secondary', 'spa-btn--small');
      compareSelector.classList.remove('spa-input', 'spa-input-options', 'spa-input--sparta2');
    });
    const compareMediumSelectors = document.querySelectorAll('.show-for-medium-up .compare-selector .spa-input');
    Array.from(compareMediumSelectors).forEach(compareSelector => {
      compareSelector.classList.add('spa-btn', 'spa-btn--secondary', 'spa-btn--medium');
      compareSelector.classList.remove('spa-input', 'spa-input-options', 'spa-input--sparta2');
    });
  }

  /**
   * generateCardCatalog
   *
   * @description Swaps out the tokens from JCR cardContent since the links are used dynamically.
   * @param {Object} campaign - campaign containing product data
   * @returns {void}
   */
  generateCardCatalog(campaign) {
    // Expose site params to use in jcr such as site.siteRoot
    const data = {
      site: spaParams.siteParams,
      ...campaign
    };
    const cardContentString = JSON.stringify(this.cardContent);
    const generated = JSON.parse(Handlebars.compile(cardContentString)(data));
    return generated;
  }

  /**
   * renderList
   * @returns {void}
   */
  renderList() {
    const campaigns = [];
    const properties = this.cardContent.campaignProperties;
    this.cardList.forEach(cardList => {
      if (cardList.campaign) {
        const campaignId = cardList.campaign.split('~').splice(0, 2).join('~');
        campaigns.push(campaignId);
      }
    });
    sbCreditCardUtility.productPropertiesMap(this.params.requestParams, campaigns, properties).then(result => {
      this.campaignData = result;
      let cardsHtml = '';
      Object.keys(result).forEach(campaignId => {
        const data = result[campaignId];
        const campaign = Object.assign(data, {
          ID: campaignId,
          BYAPAGE_ENABLE: data.BYAPAGE_ENABLE && data.BYAPAGE_ENABLE.toLowerCase() === 'yes',
          rating: {
            toggle: data.PRODUCT_REVIEW_RATING_ENABLE,
            value: data.PRODUCT_REVIEW_RATING,
            URL: data.PRODUCT_REVIEW_RATING_VALUE
          }
        });
        const content = this.generateCardContent(campaign);
        const cardInfo = this.cardList.filter(card => card.campaign === campaignId)[0] || {};
        const catalog = this.generateCardCatalog(campaignId, this.cardCatalogs, this.params);
        let renderedTemplate = this.templateCardInfo({
          content,
          campaign,
          params: this.params,
          site: spaParams.siteParams,
          sparta,
          cardInfo,
          catalog
        });

        // Populate any offer terms links
        renderedTemplate = this.getRenderedTemplateWithPopulatedPcmLinks(this.cardContent, campaign, cardInfo, renderedTemplate);
        cardsHtml += renderedTemplate;
      });
      this.settings.target.querySelector('.cards-list-placeholder').innerHTML = cardsHtml;

      // Only run filter on render if we have any
      if (Object.keys(this.params.filter).length) {
        this.filterCardsUi(this.params.filter);
      }
      this.Events.pub(sbCreditCardUtility.EVENTS.cardListReady, {
        id: this.settings.target.id
      });
      this.Events.sub(sbCreditCardUtility.EVENTS.compareData, this.handleCompareData.bind(this), true);
      if (this.bactmProducts.products && typeof bactm !== 'undefined') {
        bactm.addProducts(this.bactmProducts.products);
        bactm.productview();
      }
      const firstVisibleCardEl = this.settings.target.querySelector('[data-campaign].visible');
      sbCreditCardUtility.prefetchCard(firstVisibleCardEl);
      this.changeCompareStyle();
    }).catch(error => {
      this.Events.pub(sbCreditCardUtility.EVENTS.errorShowHome, {});
      // eslint-disable-next-line no-console
      console.error(error); // eventually use the core debug utility for this
    });
  }

  /**
   * generateCardContent
   *
   * @description Swaps out the tokens from JCR cardContent since the links are used dynamically.
   * @param {Object} campaign -
   * @returns {void}
   */
  generateCardContent(campaign) {
    // Fix encoding issues and srcset due to pcm content containing spaces
    const fixedCampaign = {
      ...campaign,
      CARD_IMAGE_SMALL: encodeURI(campaign.CARD_IMAGE_SMALL),
      APPLICATION_DISPLAY_HEADER_CARD_Image_URL: encodeURI(campaign.APPLICATION_DISPLAY_HEADER_CARD_Image_URL)
    };

    // Expose site params to use in jcr such as site.siteRoot
    const data = {
      site: spaParams.siteParams,
      ...fixedCampaign
    };
    try {
      const cardContentString = JSON.stringify(this.cardContent);
      const generated = JSON.parse(Handlebars.compile(cardContentString)(data));
      return generated;
    } catch (exception) {
      return null;
    }
  }

  /**
   * filterCardsUi
   *
   * @description Show and hide different cards on the page based on filters.
   * The page filters are set in the module params and multiple can be applied:
   * "filter": {
   *   "type": "masterCard", // "visa"
   *   "features": ["preferredRewards"],
   *   "ratesFees": ["noAnnualFee", "noForeignTransactionFee", "zeroAprBalance", "zeroAprPurchase"],
   *   "category": ["cash", "lowInterest", "buildCredit", "points", "students", "travel"]
   * }
   *
   * @see README.md
   * @param {Object} filter Could be a Filter obj but didn't want to overengineer it. Example above.
   * @returns {void}
   */
  filterCardsUi(filter) {
    let count = 0;
    this.cardList.forEach(cardList => {
      if (cardList.campaign) {
        const cardEl = this.settings.target.querySelector(`[data-campaign="${cardList.campaign}"]`);
        if (cardEl) {
          cardEl.classList.remove('visible');
          cardEl.setAttribute('aria-hidden', 'true');
          this.setShowHideDetails(cardEl, cardList);

          // Filter made human readable
          const hasType = this.hasType(filter.type, cardList.type, true);
          const hasCategory = this.hasCategory(filter.category, cardList.category, true, false);
          const hasFeature = this.hasFeature(filter.features, cardList.features, true, true);
          const hasRatesFees = this.hasRatesFees(filter.ratesFees, cardList.ratesFees, true, false);
          if (hasType && hasCategory && hasFeature && hasRatesFees) {
            this.updateApplyNowTrackingCodes(cardEl, cardList, filter);
            cardEl.classList.add('visible');
            cardEl.setAttribute('aria-hidden', 'false');
            // Moving the coremtric productView to the product-filter-cc-module
            // This was made so the subnav trigger different product and page views
            // this.bactmAdd(cardEl);
            count += 1;
          }
        }
      }
    });

    // Publish the count
    this.Events.pub(sbCreditCardUtility.EVENTS.cardListCount, {
      id: this.settings.target.id,
      count
    });

    // Always recalc sticky due to dom changes
    spartaStickyUtility.recalcStickyEls();
  }

  /**
   * setShowHideDetails
   *
   * @description Initialize and transform the show hide details that PCM provides.
   * The old way use to do a document element lookup and use the campaign attribute.
   * Can save CPU cycles by not repeating another loop and lookup.
   * @param {Element} cardEl - card element container
   * @param {Object} cardInfo - card object
   * @returns {void}
   */
  setShowHideDetails(cardEl, cardInfo) {
    // eslint-disable-line
    const campaignId = cardInfo.campaign;
    const showAndHideDetails = cardEl.querySelectorAll('.showDetails, .hideDetails');
    Array.from(showAndHideDetails).forEach((showAndHideDetail, i) => {
      const showType = showAndHideDetail.classList.contains('showDetails') ? 'show' : 'hide';

      // Generate anchor link to replace span with
      const anchor = document.createElement('a');
      anchor.innerHTML = showAndHideDetail.innerHTML;
      anchor.className = showAndHideDetail.className;
      anchor.tabIndex = 0;
      anchor.href = 'javascript:void(0);'; // eslint-disable-line
      anchor.id = `${showType}-details-${campaignId}-${i}`;
      if (showType === 'hide') {
        anchor.dataset.toggleId = `show-details-${campaignId}-${i - 1}`;
      }
      showAndHideDetail.parentNode.replaceChild(anchor, showAndHideDetail);
    });
  }

  /**
   * updateApplyNowTrackingCodes
   *
   * @param {Element} cardEl Card element
   * @param {Object} cardInfo Card Info
   * @return {void}
   */
  updateApplyNowTrackingCodes(cardEl, cardInfo) {
    const category = cardInfo.category && cardInfo.category.length ? cardInfo.category[cardInfo.category.length - 1] : undefined;
    const catalog = this.generateCardCatalog(cardInfo.campaign, this.cardCatalogs, this.params, category);
    const applyLink = cardEl.querySelectorAll('.apply');
    if (applyLink && applyLink.length) {
      Array.from(applyLink).forEach(link => {
        const parsed = cardListCcModuleJS.parseQueryString(link.search.substring(1));
        parsed.mktg_track = catalog.marketingTrack;
        const serialized = cardListCcModuleJS.serializeObj(parsed);
        link.href = `${link.protocol}//${link.host}${link.pathname}?${serialized}`;
      });
    }
  }

  /**
   * hasType
   *
   * @description Checks if the card has the type in the filter
   * @param {String} filterType -
   * @param {Object} cardType -
   * @param {Bool} defaultReturn -
   * @returns {Bool} has type
   */
  hasType(filterType, cardType, defaultReturn = true) {
    // eslint-disable-line
    let hasType = defaultReturn;
    if (filterType) {
      hasType = false;
    }
    if (filterType === cardType) {
      hasType = true;
    }
    return hasType;
  }

  /**
   * hasCategory
   *
   * @description Checks if the card has the category in the filter
   * @param {Object} filterCategory -
   * @param {Object} cardCategory -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has category
   */
  hasCategory(filterCategory, cardCategory, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasCategory = defaultReturn;
    if (filterCategory) {
      hasCategory = false;
      const filteredCategory = filterCategory.filter(category => cardCategory.indexOf(category) >= 0); // eslint-disable-line

      if (greedy) {
        hasCategory = filteredCategory.length > 0;
      } else {
        hasCategory = filteredCategory.length === filterCategory.length;
      }
    }
    return hasCategory;
  }

  /**
   * hasFeature
   *
   * @description Checks if the card has the features in the filter
   * @param {Object} filterFeatures -
   * @param {Object} cardFeatures -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has feature
   */
  hasFeature(filterFeatures, cardFeatures, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasFeature = defaultReturn;
    if (filterFeatures) {
      hasFeature = false;
      const filteredFeatures = filterFeatures.filter(feature => cardFeatures.indexOf(feature) >= 0); // eslint-disable-line

      if (greedy) {
        hasFeature = filteredFeatures.length > 0;
      } else {
        hasFeature = filteredFeatures.length === filterFeatures.length;
      }
    }
    return hasFeature;
  }

  /**
   * hasRatesFees
   *
   * @description Checks if the card has the rates fees in the filter
   * @param {Object} filterRatesFees -
   * @param {Object} cardRatesFees -
   * @param {Bool} defaultReturn -
   * @param {Bool} greedy -
   * @returns {Bool} has rates fees
   */
  hasRatesFees(filterRatesFees, cardRatesFees, defaultReturn = true, greedy = true) {
    // eslint-disable-line
    let hasRatesFees = defaultReturn;
    if (filterRatesFees) {
      hasRatesFees = false;
      const filteredFeatures = filterRatesFees.filter(feature => cardRatesFees.indexOf(feature) >= 0); // eslint-disable-line

      if (greedy) {
        hasRatesFees = filteredFeatures.length > 0;
      } else {
        hasRatesFees = filteredFeatures.length === filterRatesFees.length;
      }
    }
    return hasRatesFees;
  }

  /**
   * bindEvents
   * @returns {void}
   */
  bindEvents() {
    spartaEventsUtility.sub(sbCreditCardUtility.EVENTS.cardListFilter, this.handleCardListFilter.bind(this));
  }

  /**
   * handleCardListFilter
   *
   * @param {Object} res Published response
   * @returns {void}
   */
  handleCardListFilter(res) {
    const {
      data
    } = res;
    if (data.id && this.settings.target.id === data.id) {
      this.filterCardsUi(data.filter);
    }
  }

  /**
   * bindEventListeners
   *
   * @description Binds the event listeners for the module
   * @returns {void}
   */
  bindEventListeners() {
    const {
      target
    } = this.settings;
    sbCreditCardUtility.delegateEvent('click', '.showDetails', this.handleShowDetails.bind(this), false, target);
    sbCreditCardUtility.delegateEvent('click', '.hideDetails', this.handleHideDetails.bind(this), false, target);
    sbCreditCardUtility.delegateEvent('click', '.spa-accordion-link', this.handleToggleAccordion.bind(this), false, target);
    sbCreditCardUtility.delegateEvent('click', '.spa-boa-tnc-window', this.handleTermsLink.bind(this), false, target);
    sbCreditCardUtility.delegateEvent('click', '.spa-boa-program-rules-window', this.handleRulesLink.bind(this), false, target);
    sbCreditCardUtility.delegateEvent('change', '.compare-selector input', this.handleCompareAdd.bind(this), false, target);

    // cannot use delegateEvent
    // because this element's parent (.spa-accordion-link)
    // will reverse the action by toggling again
    const allArrows = this.settings.target.querySelectorAll('.spa-accordion-arrow');
    if (allArrows) {
      [...allArrows].forEach(arrow => {
        arrow.addEventListener('click', this.handleToggleAccordion.bind(this));
      });
    }
  }

  /**
   * handleApplyLink
   *
   * @description Handles the apply link events
   * @returns {void}
   */
  handleApplyLink() {
    this.Events.pub(sbCreditCardUtility.EVENTS.loaderShow, {});
  }

  /**
   * handleShowDetails
   *
   * @description Sets the active class on the show, css sibling selector will show the details
   * @param {Event} e - click event
   * @returns {void}
   */
  handleShowDetails(e) {
    // eslint-disable-line
    e.preventDefault();
    e.target.classList.toggle('active');
  }

  /**
   * handleHideDetails
   *
   * @description Toggles the show cta active class from the data attribute we set for toggle id
   * @param {Event} e - click event
   * @returns {void}
   */
  handleHideDetails(e) {
    // eslint-disable-line
    e.preventDefault();
    const {
      toggleId
    } = e.target.dataset;
    document.getElementById(toggleId).classList.toggle('active');
  }

  /**
   * handleToggleAccordion
   *
   * @description Toggles the accordion that is used for small viewport
   * @param {Event} e - click event
   * @returns {void}
   */
  handleToggleAccordion(e) {
    e.preventDefault();
    const toggleLink = e.target;
    e.target.closest('.spa-accordion-item').classList.toggle('active');
    if (e.target.classList.contains('show-less') || e.target.classList.contains('show-more')) {
      e.target.closest('.spa-accordion-link').lastElementChild.classList.toggle('active');
    } else if (e.target.classList.contains('spa-accordion-arrow')) {
      e.target.classList.toggle('active');
      const toggleItem = e.target.parentNode;
      const toggleContent = toggleItem.parentNode.parentNode.querySelector('.spa-accordion-content');
      if (toggleLink.classList.contains('active')) {
        toggleContent.setAttribute('aria-hidden', 'false');
        toggleItem.setAttribute('aria-expanded', 'true');
      } else {
        toggleContent.setAttribute('aria-hidden', 'true');
        toggleItem.setAttribute('aria-expanded', 'false');
      }
    } else if (!e.target.classList.contains('spa-accordion-arrow')) {
      const toggleItem = e.target.parentNode.parentNode;
      const toggleContent = toggleItem.querySelector('.spa-accordion-content');
      if (toggleItem.classList.contains('active')) {
        toggleLink.setAttribute('aria-expanded', 'true');
        toggleContent.setAttribute('aria-hidden', 'false');
        toggleLink.querySelector('span').classList.add('active');
      } else {
        toggleLink.setAttribute('aria-expanded', 'false');
        toggleContent.setAttribute('aria-hidden', 'true');
        toggleLink.querySelector('span').classList.remove('active');
      }
    }
  }

  /**
   * handleTermsLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleTermsLink(e) {
    e.preventDefault();
    sbCreditCardUtility.openPopupLink(e, 'termsAndConditions');
  }

  /**
   * handleRulesLink
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleRulesLink(e) {
    e.preventDefault();
    sbCreditCardUtility.openPopupLink(e, 'programRulesWin');
  }

  /**
   * handleCompareAdd
   *
   * @param {Event} e - click event
   * @returns {void}
   */
  handleCompareAdd(e) {
    const {
      dataset
    } = e.target;
    this.Events.pub(sbCreditCardUtility.EVENTS.compareUpdate, {
      ...dataset
    });
  }

  /**
   * handleCompareData
   *
   * @param {Object} res - published reponse
   * @returns {void}
   */
  handleCompareData(res) {
    const {
      target
    } = this.settings;
    const {
      data
    } = res;
    const {
      campaigns
    } = data;
    if (!campaigns) return;
    this.resetActiveCompare();
    campaigns.forEach(campaign => {
      const inputEl = target.querySelector(`input[data-campaign="${campaign.campaign}"]`);
      if (!inputEl) return;
      const parentId = inputEl.dataset.parent;
      inputEl.checked = true;
      const cardEl = target.querySelector(`[data-campaign="${parentId}"]`);
      if (!cardEl) return;
      cardEl.classList.add('compare');
      const labelEl = target.querySelectorAll(`[for="compare-${parentId}"]`);
      Array.from(labelEl).forEach(labelE => {
        if (labelE.childNodes.length > 0) {
          labelE.childNodes[0].nodeValue = this.cardContent.compareRemoveLabel;
        }
      });
    });
  }

  /**
   * resetActiveCompare
   * @returns {void}
   */
  resetActiveCompare() {
    const cards = this.settings.target.querySelectorAll('.card-info');
    Array.from(cards).forEach(card => {
      card.classList.remove('compare');
      const input = card.querySelector('input[type=checkbox]');
      if (input) {
        input.checked = false;
        const labelEl = card.querySelectorAll(`[for="compare-${card.getAttribute('data-campaign')}"]`);
        Array.from(labelEl).forEach(labelE => {
          if (labelE.childNodes.length > 0) {
            labelE.childNodes[0].nodeValue = this.cardContent.compareLabel;
          }
        });
      }
    });
  }

  /**
   * bactmAdd
   *
   * @description Add products to coremetrics
   * @param {Element} cardInfoEl - card info container element
   * @returns {void}
   */
  bactmAdd(cardInfoEl) {
    const data = cardInfoEl.dataset;

    /* eslint-disable */
    if (typeof bactm_addProducts !== 'undefined' && !data.cmProductAdded) {
      const productId = `${data.groupCode} ${data.sourceCode}`.trim();
      const {
        productName
      } = data;
      bactm_addProducts(productId, productName, this.params.prodCategoryId);
      data.cmProductAdded = true;
      bactm_productView();
    }
    /* eslint-enable */
  }

  /**
   * serializeObj
   *
   * @description serializes an object and returns a query string
   * @param {Object} obj unserialized
   * @returns {String} string of serialized object
   */
  static serializeObj(obj) {
    const str = [];
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    }
    return str.join('&');
  }

  /**
   * parseQueryString
   *
   * @description parse query string and returns an object
   * @param {String} str query string
   * @returns {Object} parsed query string object
   */
  static parseQueryString(str) {
    try {
      return JSON.parse(`{"${str.replace(/&/g, '","').replace(/=/g, '":"')}"}`, (key, value) => key === '' ? value : decodeURIComponent(value));
    } catch (exception) {
      return null;
    }
  }

  /**
   * @description Any offer terms links sent from PCM need to be updated
   * with the same href and class generated by the termsAndConditions helper.
   * @param {Object} content content
   * @param {Object} campaign campaign
   * @param {Object} cardInfo campaign properties
   * @param {String} renderedTemplate renderedTemplate
   * @returns {String} rendered template with populated offer terms links
   */
  getRenderedTemplateWithPopulatedPcmLinks(content, campaign, cardInfo, renderedTemplate) {
    // Parse renderedTemplate
    const tempRenderedTemplateEl = document.createElement('div');
    tempRenderedTemplateEl.innerHTML = renderedTemplate;
    const pcmOfferTermsLinks = tempRenderedTemplateEl.querySelectorAll("[href='#creditCardTnCAnchor']");

    // Check for offer terms links
    if (pcmOfferTermsLinks && pcmOfferTermsLinks.length > 0) {
      // Create Offer Terms TnC pop-up link string.
      const anchorString = sbCreditCardsHelper.helpers.termsAndConditions(content.LINKS.termsAndConditionOffer, cardInfo.campaign, spaParams.siteParams, sparta, true, 'See Offer Terms' // Temporary string that will not be used ( we just need the href )
      );

      // Parse string for URL and programmatically obtain the href.
      const tempDivEl = document.createElement('div');
      tempDivEl.innerHTML = anchorString;
      const parsedAnchorTag = new URL(tempDivEl.firstChild);

      // Populate any links sent from PCM with the href and associated class
      pcmOfferTermsLinks.forEach(pcmLink => {
        // eslint-disable-next-line no-param-reassign
        pcmLink.href = parsedAnchorTag.href;
        pcmLink.classList.add('spa-boa-tnc-window');
      });
      return tempRenderedTemplateEl.innerHTML;
    }
    return renderedTemplate;
  }
}
registerModuleClass({
  moduleClass: cardListCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { cardListCcModuleJS as default, moduleConfig };
